import { Reveal } from "@/components/shared/Reveal";
import { Button } from "@/components/shared/Button";
import { CtaTrust } from "@/components/shared/CtaTrust";
import { ANCHORS } from "@/config/routes";
import { WORKSHOP } from "@/config/workshop";

export function Einladung() {
  return (
    <section className="einladung" aria-label="Einladung">
      <Reveal className="wrap" as="div">
        <h2 className="einladung-title">
          <span>Vielleicht beginnt hier</span>
          <span>ein anderer Blick auf deinen Körper.</span>
        </h2>

        <div className="einladung-details">
          <p>{`${WORKSHOP.dateLong} · ${WORKSHOP.time}`}</p>
          <p>{WORKSHOP.locationShort}</p>
          <p className="bring">Bring nur dich selbst mit.</p>
        </div>

        <Button href={ANCHORS.buchung} data-testid="einladung-cta">
          Ich möchte dabei sein
        </Button>

        <CtaTrust />
      </Reveal>
    </section>
  );
}
